module.exports = __webpack_public_path__ + "static/media/easy_installation_bg_icon.326dc03f.svg";